const vitalsValidation = (onPerfEntry) => onPerfEntry && onPerfEntry instanceof Function;

const reportWebVitals = (onPerfEntry) => {
  if (vitalsValidation(onPerfEntry)) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
